import { cdn_url } from '../../../mixins/cdnUrl';

const state = {
    header: {},
};

const getters = {
    get: () => state.header,
    title: () => state.header.title || 'ConnectPlug',
    favicon: () => state.header.favicon || cdn_url('core/favicon.ico'),
    colors: () => state.header.colors || {},
    isWhitelabel: () => state.header.isWhitelabel || false
};

const mutations = {
    SET(state, data) {
        state.header = _.isPlainObject(data) ? data : {};
    }
};

const actions = {
    set({ commit }, data) {
        commit('SET', data)
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
